import * as React from "react";
import { IconType } from "./types";

const GiftCard: IconType = (props) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.7244 21.8457H64.6935C67.6415 21.8457 69.9999 23.8984 69.9999 26.5926V53.5343C69.9999 56.1002 67.6415 58.1529 64.6935 58.1529H14.7244C11.7764 58.1529 9.41797 56.1002 9.41797 53.5343V26.4643C9.41797 23.8984 11.7764 21.8457 14.7244 21.8457ZM68.2311 33.649V26.4646C68.2311 24.7968 66.6097 23.5138 64.6935 23.3855H53.9332V30.6983C54.3754 29.6719 54.8176 28.6456 55.8494 27.8758C57.6182 26.4646 60.1241 26.7212 61.7455 28.2607C63.3669 29.8002 63.0721 32.1095 61.3033 33.3925C61.1559 33.5207 61.0085 33.649 60.8611 33.649H68.2311ZM11.1868 53.5353V26.4652C11.1868 24.7974 12.6609 23.5144 14.5771 23.5144H16.4933C15.7563 24.2842 15.3141 25.3106 15.3141 26.4652V53.407C15.3141 54.5616 15.7563 55.588 16.6407 56.486H14.7245C12.8083 56.486 11.1868 55.2031 11.1868 53.5353ZM54.0807 33.6491H55.4073C57.7657 33.6491 58.9449 33.3925 60.2715 32.4945C61.3033 31.5964 61.5981 30.1852 60.5663 29.1588C60.1241 28.6456 59.2397 28.2608 58.5027 28.2608C55.8495 28.2608 54.6703 31.853 54.0807 33.6491ZM45.6788 32.3662C44.647 31.3398 44.3522 30.0569 45.384 29.0305C45.8262 28.6456 46.4158 28.2608 47.1528 28.2608C49.6586 28.2608 51.2801 31.9813 51.8697 33.6491H50.5431C47.595 33.6491 46.4158 33.2642 45.6788 32.3662ZM47.1528 26.9784C48.1846 26.8501 49.2164 27.1067 50.1008 27.7482C51.0627 28.4658 51.5122 29.5179 51.927 30.4887L51.9676 30.5838L52.017 30.6989V23.5144H20.6206C18.7043 23.5144 17.2303 24.7974 17.2303 26.4652V33.6497H45.2366C45.0892 33.6497 44.9418 33.5214 44.7944 33.3931C43.91 32.7516 43.4678 31.8536 43.3204 30.9555C43.0256 28.9028 44.7944 27.235 47.1528 26.9784ZM20.6206 56.4851C18.7043 56.4851 17.2303 55.0738 17.2303 53.406V35.3165H51.7222C50.543 36.7278 48.332 39.0371 45.5314 39.2937C45.0892 39.2937 44.7944 39.6785 44.7944 39.9351C44.7944 40.32 45.0892 40.5766 45.5314 40.5766C48.332 40.4483 50.6904 38.5239 52.017 36.9844V56.4851H20.6206ZM53.9332 56.4851H64.6935C66.6097 56.4851 68.0837 55.0738 68.0837 53.5343V35.3165H54.228C55.4072 36.7278 57.6182 39.1654 60.4189 39.2937C60.8611 39.2937 61.1559 39.5503 61.1559 39.9351C61.1559 40.32 60.8611 40.5766 60.4189 40.5766C57.6182 40.4483 55.4072 38.5239 53.9332 36.9844V56.4851Z"
      fill="black"
    />
    <path
      d="M15.6093 53.9994V26.5238C15.6093 25.3391 16.0698 24.2859 16.9908 23.4961H14.8418C12.6928 23.4961 11 24.9197 11 26.4994V53.4994C11 55.2107 12.5045 56.4994 14.5 56.4994H14.6535H16.649C15.728 55.5779 15.6093 55.0525 15.6093 53.9994Z"
      fill="#E7E7E7"
    />
    <path
      d="M39.9273 49.0762H22.4518C22.0149 49.0762 21.7236 49.2412 21.7236 49.4888C21.7236 49.7363 22.0149 49.9013 22.4518 49.9013H39.9273C40.3642 49.9013 40.6555 49.7363 40.6555 49.4888C40.6555 49.2412 40.3642 49.0762 39.9273 49.0762Z"
      fill="black"
    />
    <path
      d="M30.4614 52.377H22.4518C22.0149 52.377 21.7236 52.542 21.7236 52.7895C21.7236 53.0371 22.0149 53.2021 22.4518 53.2021H30.4614C30.8983 53.2021 31.1896 53.0371 31.1896 52.7895C31.1896 52.542 30.8983 52.377 30.4614 52.377Z"
      fill="black"
    />
    <path
      d="M35.3489 52.377H32.7099C32.3657 52.377 32.1362 52.542 32.1362 52.7895C32.1362 53.0371 32.3657 53.2021 32.7099 53.2021H35.3489C35.6931 53.2021 35.9226 53.0371 35.9226 52.7895C35.9226 52.542 35.6931 52.377 35.3489 52.377Z"
      fill="black"
    />
    <rect
      x="22.6704"
      y="42.4746"
      width="6.62615"
      height="2.47549"
      fill="#E7E7E7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.4614 45.7752H22.4518C22.0149 45.7752 21.7236 45.5213 21.7236 45.1405V41.459C21.7236 41.0781 22.0149 40.8242 22.4518 40.8242H30.4614C30.8983 40.8242 31.1896 41.0781 31.1896 41.459V45.1405C31.1896 45.5213 30.8983 45.7752 30.4614 45.7752ZM29.7332 42.2209H23.1799V44.6329H29.7332V42.2209Z"
      fill="black"
    />
  </svg>
);

export default GiftCard;
